module.exports = __webpack_public_path__ + "img/Dark&Stormy_EGM.c93a7a6c.png";